import React, { useEffect, useRef } from "react";
import { useState } from "react";
import styled from "styled-components";
import { BottomSheet } from "react-spring-bottom-sheet";
import comment from "../assets/comment.png";
import like from "../assets/like.png";
import play from "../assets/play.svg";
import { useParams } from "react-router";
import { CREATOR_VIDEO_FEED } from "../constants/urls";
import ProfileDownloadIcon from "../components/mobile/ProfileDownloadIcon";
import FollowButtonProfilePic from "../components/mobile/FollowButtonProfilePic";
import Navbar from "../components/desktop/Navbar";
import VideoCard from "../components/desktop/VideoCard";
import BlueSticker from "../components/desktop/BlueSticker";
import DownloadBottomSheet from "../components/mobile/DownloadBottomSheet";
import Members from "../components/mobile/Members";
import { Swiper, SwiperSlide } from "swiper/react";
import "react-spring-bottom-sheet/dist/style.css";
import "swiper/swiper.min.css";
import "swiper/components/pagination/pagination.min.css";
import SwiperCore, { Pagination } from "swiper/core";
import Modal from "react-modal";
import BlueButton from "../components/desktop/BlueButton";
import ProfileDetails from "../components/desktop/ProfileDetails";
import GlipHeader from "../components/mobile/GlipHeader";
import RoundCard from "../components/mobile/RoundCard";
import {
  useHistory,
  useLocation,
} from "react-router-dom/cjs/react-router-dom.min";
import back from "../assets/back.svg";
import map from "../assets/map_image.svg";
import kill from "../assets/kill.svg";
import death from "../assets/death.svg";
import down from "../assets/down_arrow.svg";
import ellipse from "../assets/ellipse.svg";
import blue_tick from "../assets/blue_tick.svg";
import firebase from "firebase";


const firebaseConfig = {
  apiKey: "AIzaSyB0-YwaTmfdi6p87ZyM-qghnlrNT7ZAeCA",
  authDomain: "namaste-9d4ab.firebaseapp.com",
  databaseURL: "https://namaste-9d4ab.firebaseio.com",
  projectId: "namaste-9d4ab",
  storageBucket: "namaste-9d4ab.appspot.com",
  messagingSenderId: "373196446500",
  appId: "1:373196446500:web:8fe1a8e0502861c00df1b1",
  measurementId: "G-9SM64MNRYV",
};
// install Swiper modules
SwiperCore.use([Pagination]);

const Mobile = styled.div`
  display: none;
  @media only screen and (max-device-width: 480px) {
    display: flex;
    height: 100vh;
    flex-direction: column;
    /* overflow: hidden; */
  }
`;

const HorizontalCardHolder = styled.div`
  display: flex;
  flex-direction: row;
  overflow: scroll;
  margin-top: 15px;
  margin-bottom: 8px;
`;

const Container = styled.div`
  padding: 16px 20px;
  display: flex;
  flex-direction: column;
  /* width: 100%; */
  justify-content: space-between;
  border-bottom: 2px solid #0e0f18;
  padding-bottom: 0px;
`;

const BackArrow = styled.img`
  height: 20px;
  margin-right: 20px;
`;

const Share = styled.img`
  height: 20px;
  /* margin-right: 20px; */
`;

const Title = styled.span`
  font-family: "Poppins";
  font-style: normal;
  /* font-weight: 500; */
  font-size: 20px;
  line-height: 24px;
  color: #ffffff;
`;

const RoundTitle = styled.span`
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 18px;
  letter-spacing: 0.2px;
  color: #ffffff;
  margin: 12px;
  margin-left: 16px;
  background: rgba(20, 22, 36, 1);
`;

const IconWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  margin-top: 4px;
  margin-bottom: 10px;
`;

const Icon = ({ icon, count }) => {
  return (
    <div style={{ display: "flex", marginRight: 8, marginTop: 6 }}>
      <img src={icon} />
      {count > 0 && <span style={{ marginLeft: 4 }}>{count}</span>}
    </div>
  );
};

const Username = styled.span`
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  display: flex;
  color: #ffffff;
`;

export default function GlipListPage(props) {
  console.log('groupId', 'matchId');
  const [data, dataSet] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);
  const { matchId, groupId } = useParams();
  const history = useHistory();
  const [glips, setGlips] = useState([]);
  const [rounds, setRounds] = useState([]);
  const [videos, setVideos] = useState({});
  const [activeVideos, setActiveVideos] = useState({});
  const [users, setUsers] = useState({});
  const [activeUsers, setActiveUsers] = useState([]);
  const [videoDeepLinkUrls, setVideoDeepLinkUrls] = useState('');
  console.log(groupId, matchId);

  useEffect(() => {
    
    console.log(window.otherApp)
    if(!window.otherApp) {
        
      // Initialize Firebase
      let otherApp = firebase.initializeApp(firebaseConfig);
      // firebase.analytics();
      // const app = firebase.app();
      window.otherApp = otherApp;
    }

    const docRef = window.otherApp
      .firestore()
      .collection("matchrooms")
      .doc(groupId)
      .collection("messages")
      .doc(matchId)
      .collection("glips")
      .orderBy('timestamp', 'asc');

    docRef
      .get()
      .then(async (doc) => {
        const { docs } = doc;
        let glips = [];
        let rounds = [];
        let users = {};
        let videos = {};
        const dataPromise = docs.map((item, index) => {

          const glip = item.data();
          const roundNumber = glip.media[0].roundNumber;

          glips.push(glip);

          // Check if user data already set, if set append to it
          users[glip.sentby.id] = glip.sentby;
          // if(!users.includes(glip.sentby.id)) users.push(obj);

          // Check if round data already set, if set append to it
          if (!rounds.includes(roundNumber)) {
            rounds.push(roundNumber);
            videos[roundNumber] = [glip];
          } else {
            videos[roundNumber].push(glip);// = [glip];
          }
        });
        await Promise.all(dataPromise);
        setGlips(glips);
        setRounds(rounds);
        setVideos(videos);
        setActiveVideos(videos);
        setUsers(users);
        setActiveUsers(Object.keys(users));
        dataSet(true);

        return;
      })
      .catch((error) => {
        console.log("Error getting document:", error);
      });
  }, []);

  //   useEffect(() => {
  //     if (data) {
  //       var vid = document.getElementsByClassName(`video-0`)[0];
  //       vid.plgetay();
  //     }
  //   }, [data]);

  if (!data) {
    return <></>;
  }

  function smoothScroll(eID) {
    var elm = document.getElementById('scrolldiv');
    var startY = currentYPosition();
    var stopY = elmYPosition(eID);
    var distance = stopY > startY ? stopY - startY : startY - stopY;
    console.log(distance)
    if (true || distance < 100) {
      console.log(stopY)
      elm.scrollTo(0, stopY + 170);
      return;
    }
    var speed = Math.round(distance / 100);
    if (speed >= 20) speed = 20;
    var step = Math.round(distance / 25);
    var leapY = stopY > startY ? startY + step : startY - step;
    var timer = 0;
    if (stopY > startY) {
      for (var i = startY; i < stopY; i += step) {
        setTimeout(elm + ".scrollTo(0, " + leapY + ")", timer * speed);
        leapY += step;
        if (leapY > stopY) leapY = stopY;
        timer++;
      }
      return;
    }
    for (var i = startY; i > stopY; i -= step) {
      setTimeout(elm + ".scrollTo(0, " + leapY + ")", timer * speed);
      leapY -= step;
      if (leapY < stopY) leapY = stopY;
      timer++;
    }
    return false;
  }

  function elmYPosition(eID) {
    var elm = document.getElementById(eID);
    var y = elm.offsetTop;
    var node = elm;
    while (node.offsetParent && node.offsetParent != document.body) {
      node = node.offsetParent;
      y += node.offsetTop;
    }
    return y;
  }

  function currentYPosition() {
    // Firefox, Chrome, Opera, Safari
    if (self.pageYOffset) return self.pageYOffset;
    // Internet Explorer 6 - standards mode
    if (document.documentElement && document.documentElement.scrollTop)
      return document.documentElement.scrollTop;
    // Internet Explorer 6, 7 and 8
    if (document.body.scrollTop) return document.body.scrollTop;
    return 0;
  }

  const getbase64VideoUrls = (videos) => {
    let videoUrlString = '';
   
    videos.map((item) => {
      if(activeUsers.includes(item.sentby.id)) {
        // videoUrlString += Buffer.from(`https://glip.gg/groups/${groupId}/match/${matchId}/clip/${item.uid}?source=match-glips`).toString('base64') + ',';
        videoUrlString += `https://glip.gg/groups/${groupId}/match/${matchId}/clip/${item.uid}?source=match-glips` + ',';
      }
    })
    
    return Buffer.from(videoUrlString.substring(0, videoUrlString.length - 1)).toString('base64');
  }

  const getIndex = (video) => {
    let index;
    glips.map((item, gindex) => {
      if(item.uid == video.uid) return index = gindex;
    })
    return index
  }

  const round_list = rounds.map((item, index) => {

    // Getting videos filtered by active user filter
    const filterdVideos = activeVideos[item].filter((video) => {
      return activeUsers.includes(video.sentby.id);          
    })

    // if(filterdVideos.length>0)
    // console.log(getbase64VideoUrls(filterdVideos))
    // Removing the round object completely if no videos are there
    if(filterdVideos.length == 0) return(<></>);

    const videos_list = filterdVideos.map((videoItem, index) => {
      return (
        <div
          style={{
            flex: "40%",
            minHeight: 120,
            background: `url('${videoItem.media[0].preview}')`,
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            backgroundRepeat: "no-repeat",
            padding: 0,
            backgroundSize: "100% 100%",
            paddingTop: 0,
            maxWidth: "50%",
          }}
          onClick={() => {
            if(window.androidEmbeded){
              // window.openDeepLink(`https://glip.gg/groups/${groupId}/match/${matchId}/clip/${videoItem.uid}?source=match-glips`)
              window.openDeepLink(`https://glip.gg/openClips?index=${getIndex(videoItem)}&urls=${getbase64VideoUrls(glips)}`)
            }
            else {
              console.log(`https://glip.gg/openClips?index=${getIndex(videoItem)}&urls=${getbase64VideoUrls(glips)}`)
              console.log(glips)
              history.push(`/clip/${videoItem.media[0].id}`)          
            }
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              background:
                "linear-gradient(0deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.6) 100%)",
              padding: 8,
            }}
          >
            <img
              src={`https://be.namasteapis.com/api/v1/profile-image/${videoItem.sentby.id}/`}
              style={{
                width: 22,
                height: 22,
                borderRadius: 20,
                marginRight: 6,
              }}
            />
            <Username>{videoItem.sentby.name}</Username>
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              paddingLeft: 8,
              background:
                "linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.6) 100%)",
            }}
          >
            <Username>{videoItem.media[0].message}</Username>
            <IconWrapper>
              {videoItem.media[0].eventType == 'Death'?<Icon icon={death}  />: <Icon icon={kill} />}
            </IconWrapper>
          </div>
        </div>
      );
    });

    // Actual round object
    return (
      <>
        <RoundTitle key={`round-title-${index}`} id={`round-title-${index}`}>
          Round {item}
        </RoundTitle>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            flexWrap: "wrap",
            background: "#0E0F18",
          }}
        >
          {videos_list}
        </div>
      </>
    );
  });

  const round_cards = rounds.map((item, index) => {

    const filterdVideos = activeVideos[item].filter((video) => {
        return activeUsers.includes(video.sentby.id);
  })

  // Removing the round object completely if no videos are there
  if(filterdVideos.length == 0) return(<></>);
  
      let kills = 0;
      let death = false;
      let spike_planted = false;
      videos[item].map(item => {
          if(item.media[0].eventType == 'Death') death = true;
          if(item.media[0].eventType == 'spike') spike_planted = true;
          if(item.media[0].eventType == 'Kill') kills += 1;
      })
    return (
      <RoundCard
        onClick={() => {
          console.log(`round-title-${index}`);
          smoothScroll(`round-title-${index}`);
          console.log(`round-title-${index}`);
        }}
        key={`round-card-${index}`}
        round={item}
        kills={kills}
        death={death}
        spike_planted={spike_planted}
      />
    );
  });

  const dropdown_list = Object.keys(users).map((item, index) => {
    const active = activeUsers.includes(item);
    return (
      <div key={`dropdownlist-${index}`} style={{ display: "flex", justifyContent: "space-between" }}>
        <div style={{display: 'flex', }}>
            <img src={`https://be.namasteapis.com/api/v1/profile-image/${item}`} style={{width: 32, height: 32, borderRadius: '50%', marginRight: 10}}/>
            <span style={{marginTop: 5}}>{users[item].name}</span>
        </div>
        {active && (
          <img
            onClick={() => {
              const acti = activeUsers.splice(activeUsers.indexOf(item.toString()), 1);
              setActiveUsers([...activeUsers]);
            }}
            src={blue_tick}
          />
        )}
        {!active && (
        <img
            src={ellipse}
            onClick={() => {
              setActiveUsers([...activeUsers, item]);
            }}
          />
        )}
      </div>
    );
  });

  return (
    <>
      <Mobile>
        <Container>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <div>
              <BackArrow
                onClick={() => {
                  if(window.androidEmbeded) {
                    window.backPressed();
                    window.unSubscribeBackPress();
                  } else {
                    props.backPress()
                  }            
                }}
                src={back}
              />
              <Title>Match Glips</Title>
            </div>
            <div style={{ display: "flex" }}>
              <Members members={[...activeUsers]} />
              <img onClick={() => setShowDropdown(true)} src={down} />
              {showDropdown && (
                <>
                  <div
                    onClick={() => setShowDropdown(false)}
                    style={{
                      position: "fixed",
                      top: 0,
                      bottom: 0,
                      left: 0,
                      right: 0,
                      background: "transparent",
                    }}
                  ></div>
                  <div
                    style={{
                      position: "absolute",
                      right: 16,
                      padding: '20px 16px',
                      background: "#141624",
                      width: 230,
                      top: 50,
                      boxShadow:
                        "0px 0px 4px rgba(0, 0, 0, 0.08), 0px 8px 8px rgba(0, 0, 0, 0.16)",
                      borderRadius: 12,
                    }}
                  >
                    {dropdown_list}
                  </div>
                </>
              )}
            </div>
          </div>
          <HorizontalCardHolder>{round_cards}</HorizontalCardHolder>
        </Container>
        <div
          style={{
            overflow: "scroll",
            display: "flex",
            flexDirection: "column",
          }}
          id={'scrolldiv'}
        >
          {round_list}
        </div>
      </Mobile>
    </>
  );
}

// module.exports = VideoPage
